import { render, staticRenderFns } from "./NewInspiration.vue?vue&type=template&id=271694ef"
import script from "./NewInspiration.vue?vue&type=script&lang=js"
export * from "./NewInspiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports